import amico from '../../assets/images/amico.png'
import amico2 from '../../assets/images/amico2.png'
import pana from '../../assets/images/pana.png'
import Portfolio from '../../assets/images/Portfolio.png'

const cards: any = [
  {
    title: 'GET STARTED',
    content:
      'At QC Express, we provide fast and reliable delivery services both locally and globally, ensuring seamless shipments to all your locations. We help businesses manage their supply chains with solutions that ensure timely deliveries while maintaining the quality of supplies.',
    icon: 'streamline:startup-solid',
    img: pana,
  },
  {
    title: 'API DOCUMENTATION',
    content:
      'This API will help your business manage shipments, track deliveries with better route optimization helping drivers take the fastest and most fuel-efficient routes improving delivery speed. Real-time tracking gives businesses and customers live updates, reducing delays and support requests, helping you build transparency  with your customers. ',
    icon: 'eos-icons:api',
    img: amico,
  },
  {
    title: 'EASY INTEGRATION',
    content:
      'Seamless API integration helps businesses run smoothly by automating key tasks like booking shipments, tracking deliveries, and managing invoices. Smart route planning cuts fuel costs, while automated billing saves time and reduces paperwork. As your business grows, API-driven logistics make it easy to expand .',
    icon: 'mdi:library',
    img: Portfolio,
  },
  {
    title: 'ACTIVE DEV SUPPORT',
    content:
      'Strong developer support means quick issue resolution, keeping the supply chain running smoothly. Our software ensures easy integration, fast deployment, and minimal downtime. With real-time support, businesses can automate shipping and tracking without delays.',
    icon: 'mingcute:question-fill',
    img: amico2,
  },
]

export default cards
